export default "__VITE_ASSET__41fabc27__"